import { render, staticRenderFns } from "./OrderCancel.vue?vue&type=template&id=c85a3426&scoped=true&"
import script from "./OrderCancel.vue?vue&type=script&lang=js&"
export * from "./OrderCancel.vue?vue&type=script&lang=js&"
import style0 from "./OrderCancel.vue?vue&type=style&index=0&id=c85a3426&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a3426",
  null
  
)

export default component.exports